import { View } from 'react-native'

import DialogueMarkdown from 'APP/Components/DialogueMarkdown'
import Typography from 'APP/Converse/Typography'

import Scale, { ScaleProps } from '../Scale'
import { Card, Header, ScaleContainer } from './styles'
import { useMarkdownStyles } from 'APP/Hooks/useMarkdownStyles'

type ScaleCardProps = {
  subtitle?: string | null
  title?: string | null
  scale?: ScaleProps
  children?: React.ReactNode
  testID?: string
}

const ScaleCard: React.FC<ScaleCardProps> = ({
  subtitle,
  title,
  scale,
  children,
  testID = 'SCALE_CARD',
}) => {
  const markdownStyles = useMarkdownStyles({ variant: 'bodyNormal' })

  return (
    <Card testID={testID}>
      <Header>
        {subtitle && <Typography variant="bodySmall">{subtitle}</Typography>}
        {title && (
          <View accessibilityRole="header" accessibilityLabel={title}>
            <Typography variant="bodyLargeBold">{title}</Typography>
          </View>
        )}
      </Header>
      {scale && scale.levels.length > 0 && (
        <ScaleContainer>
          <Scale validateValue={false} {...scale} testID={scale.testID ?? `${testID}_SCALE`} />
        </ScaleContainer>
      )}
      {typeof children === 'string' ? (
        <DialogueMarkdown markdown={children} styles={markdownStyles} containerStyles={{}} />
      ) : (
        children
      )}
    </Card>
  )
}

export default ScaleCard
